import React from "react";
import { useTranslation } from "react-i18next";
import { companyInfo } from "../../data/company";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <footer className="footer clearfix">
        <div className="container">
          {/* First footer */}
          <div className="first-footer">
            <div className="row">
              <div className="col-md-12">
                <div
                  className="links dark footer-contact-links"
                  style={{ borderRadius: "8px" }}
                >
                  <div className="footer-contact-links-wrapper">
                    <div className="footer-contact-link-wrapper">
                      <div className="image-wrapper footer-contact-link-icon">
                        <div className="icon-footer">
                          <i className="fa-solid fa-phone"></i>
                        </div>
                      </div>
                      <a
                        href={companyInfo.phoneHref}
                        className="footer-contact-link-content"
                      >
                        <h6>{t("call")}</h6>
                        <p>{companyInfo.phone}</p>
                      </a>
                    </div>
                    <div className="footer-contact-links-divider" />
                    <div className="footer-contact-link-wrapper">
                      <div className="image-wrapper footer-contact-link-icon">
                        <div className="icon-footer">
                          <i className="fa-solid fa-message"></i>
                        </div>
                      </div>
                      <a
                        href={`mailto:${companyInfo.email}`}
                        className="footer-contact-link-content"
                      >
                        <h6>{t("write")}</h6>
                        <p>{companyInfo.email}</p>
                      </a>
                    </div>
                    <div className="footer-contact-links-divider" />
                    <div
                      className="footer-contact-link-wrapper"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.open(companyInfo.publicOfferPath);
                      }}
                    >
                      <div className="image-wrapper footer-contact-link-icon">
                        <div className="icon-footer">
                          <img
                            className="fa-solid fa-location-dot"
                            src="/img/doc.png"
                            alt="Document"
                          />
                        </div>
                      </div>
                      <div className="footer-contact-link-content">
                        <h6>{t("offer")}</h6>
                        <p>{t("offer_text")}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Second footer */}
          <div className="second-footer">
            {/* <div className="row"> */}
            {/* about & social icons */}
            {/* <div className="col-md-4 widget-area">
                  <div className="widget clearfix">
                    <div className="footer-logo">
                      {" "}
                      <img
                        className="img-fluid"
                        src="img/logo-light.png"
                        alt=""
                      />{" "}
                    </div>
                    <div className="widget-text">
                      <p>
                        Quisque imperdiet sapien porttito the bibendum
                        sellentesque the commodo erat acar accumsa lobortis,
                        enim diam the nesuen.
                      </p>
                      <div className="social-icons">
                        <ul className="list-inline">
                          <li>
                            <a href="#">
                              <i className="ti-instagram" />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="ti-twitter" />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="ti-facebook" />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="ti-youtube" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}
            {/* quick links */}
            {/* <div className="col-md-3 offset-md-1 widget-area">
                  <div className="widget clearfix usful-links">
                    <h3 className="widget-title">Quick Links</h3>
                    <ul>
                      <li>
                        <a href="about.html">About</a>
                      </li>
                      <li>
                        <a href="tours.html">Tours</a>
                      </li>
                      <li>
                        <a href="destination.html">Destinations</a>
                      </li>
                      <li>
                        <a href="contact.html">Contact</a>
                      </li>
                    </ul>
                  </div>
                </div> */}
            {/* subscribe */}
            {/* <div className="col-md-4 widget-area">
                  <div className="widget clearfix">
                    <h3 className="widget-title">Subscribe</h3>
                    <p>
                      Sign up for our monthly blogletter to stay informed about
                      travel and tours
                    </p>
                    <div className="widget-newsletter">
                      <form action="#">
                        <input
                          type="email"
                          placeholder="Email Address"
                          required
                        />
                        <button type="submit">Send</button>
                      </form>
                    </div>
                  </div>
                </div> */}
            {/* </div> */}
          </div>
          {/* Bottom footer */}
          <div className="mx-auto d-flex max-w-7xl items-center justify-content-between px-4 py-6">
            <div className="flex items-center gap-6">
              <p className="text-sm text-muted-foreground">
                ©2026 {companyInfo.brandName} | {t("rights")}
              </p>
            </div>
            {/* <div className="flex items-center gap-2">
          <img
          style={{width: '60px', height: '20px'}}
            src="/img/pngaaa.com-176837.png"
            alt="Visa"
          />
        </div> */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
